/**
 * Web.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ApplicationSearchSearchResultType = {
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;
export type ApplicationSearchSearchResultType = typeof ApplicationSearchSearchResultType[keyof typeof ApplicationSearchSearchResultType];

